export const VEHICLE_INTEGRATION_ROUTE = 'vehicle-integration'
export const ADD_VEHICLE_ROUTE = 'add-vehicle'
export const CONNECT_VEHICLES_ROUTE = 'connect-vehicles'
export const VENDOR_ACCOUNT_ID = 'vendorAccount'
export const EHA_ERROR_LOGIN = 'error'
export const INSTALLATION_ID = 'installationId'
export const DAYS_OF_WEEK = 7
export const DAYS_OF_WEEK_PLUS_ONE = 8
export const MAX_CHARGE_LIMIT_VALUE = 100
export const REAUTHENTICATE_LOCAL_STORAGE_KEY = 'reauthenticate'

export const MANUFACTURERS_WITHOUT_VIN = ['BMW', 'MINI']
export const MANUFACTURERS_WITHOUT_GPS = ['BMW', 'MINI']
